module.exports = "../dist/img/upper-banner-36.ffe2.jpg";